import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

interface Props {
  className?: string;
  title: ReactNode;
  description?: ReactNode;
  rightSlot?: ReactNode;
}

export function FormSectionTitle({
  className,
  title,
  description,
  rightSlot,
}: Props): JSX.Element {
  return (
    <FlexBox alignItems="center" className={className}>
      <FlexBox flexDirection="column" flex={1} gap="200">
        <Text.Heading variant="heading-3">{title}</Text.Heading>
        {description && (
          <Text.Paragraph variant="2">{description}</Text.Paragraph>
        )}
      </FlexBox>
      {rightSlot}
    </FlexBox>
  );
}
